export const mutationNames = {
  REQUESTING: "REQUESTING",
  UPDATE_LIST: "UPDATE_LIST",
  UNSHIFT_LIST: "UNSHIFT_LIST",
  REMOVE_LIST_ITEM: "REMOVE_LIST_ITEM",
  REMOVE_SOME_ITEMS: "REMOVE_SOME_ITEMS",
  REPLACE_LIST_ITEM: "REPLACE_LIST_ITEM"
};
